const awl_script_load_loaded: { [url: string]: boolean } = {};

export function awl_script_load_reset_cache(url: string): void {
    awl_script_load_loaded[url] = false;
}

export function awl_script_load(url: string, fn: Function, cache: boolean = false): void {
    const loaded = awl_script_load_loaded;
    if (loaded[url]) {
        fn && fn();
        return;
    }
    const src = cache ? url : url + '?dice=' + Math.random();
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script') as any;
    script.setAttribute('content-type', 'text/javascript');
    script.setAttribute('src', src);
    script.onerror =
        script.onload =
        script.onreadystatechange =
            function (e) {
                if (e.type !== 'error' && typeof this.readyState !== 'undefined' && this.readyState !== 'complete') {
                    return;
                }
                this.onerror = this.onload = this.onreadystatechange = null;
                loaded[url] = true;
                const ready = e.type !== 'error';
                fn && fn(ready);
            };
    head.appendChild(script);
}
